import {reduxList} from '../../milestones/redux/templateMilestoneList';
import {ASSET_TASK_COLLECTION} from '../domain/config';
import {TaskType} from '../enums/TaskType';
import {getUpdateAssetTask} from '../reducers/state';
import {makeEditTaskModal} from './configEditTaskRequests';
import {UPDATE_ASSET_TASK_PREFIX} from './state';


export const {
  /** @type {ReduxRequestModal} */
  requestModal: updateAssetTaskRequestModal,
} = makeEditTaskModal({
  isCreate: false,
  taskType: TaskType.ASSET,
  prefix: UPDATE_ASSET_TASK_PREFIX,
  getState: getUpdateAssetTask,
  path: ASSET_TASK_COLLECTION,
  milestoneReduxList: reduxList,
});



// WEBPACK FOOTER //
// ./src/js/tasks/redux/updateAssetTask.js